"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;

var _react = require("react");

var _ = require("..");

var _atoms = require("../atoms");

var _jsxRuntime = require("react/jsx-runtime");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var icons = {
  success: 'checkmark',
  info: 'info',
  action: 'waiting',
  warning: 'warning',
  error: 'alert',
  clear: 'waiting'
};

var Banner = function Banner(_ref) {
  var type = _ref.type,
      label = _ref.label,
      badge = _ref.badge,
      extended = _ref.extended,
      _ref$extendable = _ref.extendable,
      extendable = _ref$extendable === void 0 ? true : _ref$extendable,
      children = _ref.children;

  var _useState = (0, _react.useState)(extended),
      _useState2 = _slicedToArray(_useState, 2),
      isExtended = _useState2[0],
      setExtended = _useState2[1];

  var handleToggle = function handleToggle() {
    return setExtended(function (value) {
      return !value;
    });
  };

  return (0, _jsxRuntime.jsxs)(_.Box, {
    mb: "2",
    variant: "banner.".concat(type),
    sx: {
      borderRadius: 'banner'
    },
    children: [(0, _jsxRuntime.jsxs)(_.Flex, {
      variant: "horizontal-start",
      p: extendable ? '2' : '3',
      pb: '2',
      px: type === 'clear' && '0',
      justifyContent: "space-between",
      onClick: children && extendable ? handleToggle : undefined,
      sx: {
        cursor: children && extendable && 'pointer'
      },
      "data-testid": "banner-toggle",
      children: [(0, _jsxRuntime.jsxs)(_.Flex, {
        variant: "horizontal-start",
        children: [(0, _jsxRuntime.jsx)(_.Icon, {
          type: icons[type],
          width: "20px",
          minWidth: "20px",
          height: "20px",
          mr: "2"
        }), (0, _jsxRuntime.jsx)(_.Body, {
          color: "inherit",
          fontSize: "1",
          fontWeight: "bold",
          sx: {
            textTransform: 'uppercase',
            wordBreak: 'break-word'
          },
          children: label
        })]
      }), (0, _jsxRuntime.jsxs)(_.Flex, {
        variant: "horizontal-start",
        minWidth: "10px",
        children: [badge && (0, _jsxRuntime.jsx)(_atoms.Badge, {
          type: type,
          children: badge
        }), children && extendable && (0, _jsxRuntime.jsx)(_.Icon, {
          type: "caret",
          ml: "2",
          width: "10px",
          minWidth: "10px",
          sx: {
            userSelect: 'none',
            transform: isExtended ? 'rotate(180deg)' : ''
          }
        })]
      })]
    }), children && (isExtended || !extendable) && (0, _jsxRuntime.jsx)(_.Body, {
      fontSize: "0.875rem",
      p: extendable ? '2' : '3',
      pt: "0",
      children: children
    })]
  });
};

exports.Banner = Banner;